var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17.5998L34 31.3262C34.0008 31.5481 33.9135 31.7612 33.7573 31.9188C33.6011 32.0763 33.3887 32.1654 33.1669 32.1665L12.0008 32.1665C11.8688 32.166 11.7382 32.1394 11.6165 32.0885C11.4948 32.0375 11.3844 31.963 11.2914 31.8693C11.1985 31.7756 11.1249 31.6645 11.0749 31.5424C11.0249 31.4203 10.9995 31.2895 11 31.1576L11 14.0088C10.9995 13.8768 11.0249 13.746 11.0749 13.6239C11.1249 13.5018 11.1985 13.3907 11.2914 13.297C11.3844 13.2034 11.4948 13.1289 11.6165 13.0779C11.7382 13.0269 11.8688 13.0004 12.0008 12.9998L14.8354 12.9998",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3021 12.9996L30.3742 17.5996L23.6398 17.5996L21.5677 12.9996L28.3021 12.9996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9644 12.9996C33.5368 12.9996 33.9999 13.6865 33.9999 14.5329L33.9999 17.5996L30.3731 17.5996L28.301 12.9996L32.9644 12.9996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5687 12.9996L23.6397 17.5996L17.9419 17.5996C17.5868 17.542 17.2524 17.3945 16.9704 17.1713C16.6885 16.948 16.4683 16.6563 16.3308 16.3239L14.8353 12.9996L21.5687 12.9996Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/Tabs.166073c334591b771ee5185fce2da1e9.svg";
export { ForwardRef as ReactComponent };